/* eslint-disable */
export const messageTableConstants = {
    MESSAGE_TABLE_REQUEST: 'MESSAGE_TABLE_REQUEST',
    MESSAGE_TABLE_SUCCESS: 'MESSAGE_TABLE_SUCCESS',
    MESSAGE_TABLE_ERROR: 'MESSAGE_TABLE_ERRORR',
    MESSAGE_TABLE_POST_REQUEST: 'MESSAGE_TABLE_POST_REQUEST',
    MESSAGE_TABLE_POST_SUCCESS: 'MESSAGE_TABLE_POST_SUCCESS',
    MESSAGE_TABLE_POST_ERROR: 'MESSAGE_TABLE_POST_ERROR',
    MESSAGE_TABLE_POST_RESET: 'MESSAGE_TABLE_POST_RESET'
};
